import { useState } from "react";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import axios from "axios"; // TODO: feature/improve-axios-safety リリース後にaxiosのwrapper関数に置き換える

type Prefecture = {
  value: number;
  label: string;
};

export const useFetchPrefectures = (
  fetchUrl: string,
  defaultPrefectureOptions: readonly Prefecture[],
  defaultPrefectureId: number | null,
) => {
  const [prefectureOptions, setPrefectureOptions] =
    useState<readonly Prefecture[]>(defaultPrefectureOptions);
  const [currentPrefectureId, setCurrentPrefectureId] = useState<number | undefined>(
    defaultPrefectureId ?? undefined,
  );

  const fetchPrefectures = async (workId: string | undefined) => {
    // 求人を選択していない場合と、求人を自動選択している場合は都道府県の選択肢を空にする
    if (!workId || workId === "auto") {
      setPrefectureOptions([]);
      setCurrentPrefectureId(undefined);
      return;
    }

    try {
      const { data } = await axios.get<[string, number][]>(fetchUrl, {
        params: { work_id: workId },
      });
      // [都道府県名, 都道府県ID] の形式でデータが返る
      setPrefectureOptions(
        data.map((prefecture) => ({ label: prefecture[0], value: prefecture[1] })),
      );

      // 現在の都道府県が選択肢にない場合は、選択を解除
      if (!data.some((item) => item[1] === currentPrefectureId)) {
        setCurrentPrefectureId(undefined);
      }
    } catch (error) {
      sendErrorLog(error as Error);
    }
  };

  const handlePrefectureChange = (value: number | undefined) => {
    setCurrentPrefectureId(value);
  };

  return { currentPrefectureId, prefectureOptions, fetchPrefectures, handlePrefectureChange };
};
